import { render } from "./product-carousel.vue?vue&type=template&id=19323e5e"
import script from "./product-carousel.vue?vue&type=script&lang=js"
export * from "./product-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__